import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { School, ArrowUpRight } from 'lucide-react';
import { api } from '../../lib/api';

// DistrictMembersPanel — Sprint D item 1.13.
// Renders on AccountDetail when account.type === 'district'. Shows the list
// of member schools (linked via accounts.parent_district_account_id) with
// quick-link to each school's detail page.

export default function DistrictMembersPanel({ districtAccountId }) {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!districtAccountId) return;
    let alive = true;
    setLoading(true);
    api.get(`/api/admin/accounts?parent_district=${encodeURIComponent(districtAccountId)}&limit=200`)
      .then((d) => { if (alive) setMembers(d.accounts || d.rows || []); })
      .catch((err) => { if (alive) setError(err?.data?.error || err?.message || 'Failed to load'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [districtAccountId]);

  return (
    <div data-testid="district-members-panel" className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-gray-500 mb-3">
        <School className="w-3 h-3" />
        Member schools
      </div>
      {loading && <div className="text-[12px] text-gray-500">Loading…</div>}
      {error && <div className="text-[12px] text-red-300/90">{error}</div>}
      {!loading && !error && members.length === 0 && (
        <div className="text-[12px] text-gray-500">No member schools linked yet.</div>
      )}
      <ul className="divide-y divide-white/[0.04]">
        {members.map((m) => (
          <li key={m.id} data-testid={`district-member-${m.id}`} className="flex items-center justify-between py-2">
            <div>
              <div className="text-[13px] text-white">{m.name}</div>
              <div className="text-[11px] text-gray-500">
                {m.typeSchoolDbn && `DBN ${m.typeSchoolDbn} · `}
                {m.lifecycleStage}
              </div>
            </div>
            <Link to={`/admin/accounts/${m.id}`} className="inline-flex items-center gap-1 text-[12px] text-gray-300 hover:text-white">
              View <ArrowUpRight className="w-3 h-3" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
